export class EthicsComplianceAnswerModel
{
    Id:number;
    IdRequest:number;
    IdQuestionDetail:number;
    Answer:string;
    Section:number;
    Question:number;
    SubQuestion:number;
}